module.exports = __webpack_public_path__ + "media/images/athletes/4277-8dc6e1789683bf6c86fd79cb1717ed28.png";